/* -------------------------------------------------------------------------- */
/*               Componente SlidingPaneAddEditDowntimeReason                  */
/* -------------------------------------------------------------------------- */
// Este componente permite crear o editar razones de tiempo de inactividad

import { Controller, useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import SlidingPane from 'react-sliding-pane';
import { Col, Row } from 'reactstrap';
import FormActions from 'views/components/FormActions';
import { v4 as uuidv4 } from 'uuid';
import * as organizationActions from 'views/screens/Organizations/actions';
import TextInput from '../../formComponents/TextInput';

interface Props {
  downtimeReason?: any;
  organization: any;
  isOpenSlidingPane: any;
  closeSlidingPaneAddEditDowntimeReason: (value) => void;
}

const SlidingPaneAddEditDowntimeReason = (props: Props) => {
  const {
    downtimeReason = undefined,
    organization,
    isOpenSlidingPane,
    closeSlidingPaneAddEditDowntimeReason
  } = props;
  const { control, handleSubmit, watch, reset } = useForm();
  const intl = useIntl();
  const dispatch = useDispatch();

  const { isNew, initialValues } = {
    isNew: downtimeReason === undefined || downtimeReason === null,
    initialValues: downtimeReason
  };

  const saveDowntimeReason = (values) => {
    isNew
      ? dispatch(
          organizationActions.startAddingOrganizationDowntimeReason({
            organizationId: organization?.organizationId,
            reasonId: uuidv4(),
            reasonDescription: values.reasonDescription
          })
        )
      : dispatch(
          organizationActions.startEditingOrganizationDowntimeReason({
            organizationId: organization?.organizationId,
            reasonId: downtimeReason.reasonId,
            reasonDescription: values.reasonDescription
          })
        );
    closeSlidingPaneAddEditDowntimeReason(true);
    reset();
  };

  return organization !== undefined && organization !== null ? (
    <SlidingPane
      className="custom-sliding-pane"
      overlayClassName="custom-overlay-sliding-pane"
      isOpen={isOpenSlidingPane}
      title={intl.formatMessage({
        id: isNew ? 'organizations.createDowntimeReason' : 'organizations.editDowntimeReason'
      })}
      //subtitle={isNew ? undefined : initialValues?.customerName}
      width={'35rem'}
      onRequestClose={() => {
        closeSlidingPaneAddEditDowntimeReason(false);
        reset();
      }}
    >
      <>
        <Row>
          <Col sm="12">
            <Controller
              control={control}
              name="reasonDescription"
              defaultValue={initialValues?.reasonDescription}
              rules={{ required: true }}
              render={({ field, fieldState }) => (
                <TextInput
                  field={field}
                  fieldstate={fieldState}
                  id={'reasonDescriptionInput'}
                  label={intl.formatMessage({
                    id: 'organizations.reason'
                  })}
                  required
                />
              )}
            />
          </Col>
        </Row>
        <FormActions
          variant="footer"
          saveType="button"
          onSave={handleSubmit((values) => saveDowntimeReason(values))}
          onCancel={() => {
            closeSlidingPaneAddEditDowntimeReason(false);
            reset();
          }}
        />
      </>
    </SlidingPane>
  ) : (
    <></>
  );
};

SlidingPaneAddEditDowntimeReason.defaultProps = {};

export default SlidingPaneAddEditDowntimeReason;
